import { render, staticRenderFns } from "./AsView.vue?vue&type=template&id=774e5ac8&"
import script from "./AsView.vue?vue&type=script&lang=js&"
export * from "./AsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports